import { css } from "lit";

export const inputStyles = css`
  .input {
    outline: none;
    width: 100%;
    height: 56px;
    padding: var(--sds-size-space-400) var(--sds-size-space-600);
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    color: var(--sds-color-text-default-default);
    font:
      var(--sds-typography-weight-regular) var(--sds-typography-body-size-large) / 100%
        var(--sds-typography-family-body),
      sans-serif;

    border-radius: var(--sds-size-radius-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-secondary);

    &.with-placeholder {
      padding-top: calc(var(--sds-size-space-600) + var(--sds-size-space-100));
    }

    &:hover {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-tertiary);
      background: var(--sds-color-background-default-default-hover);
    }

    &:disabled {
      border: var(--sds-size-stroke-border) solid var(--sds-color-border-disabled-default);
      color: var(--sds-color-text-disabled-default);
      background: var(--sds-color-background-disabled-default);
      cursor: not-allowed;
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    animation-name: wow-autocomplete-detected;
    animation-duration: 0.01s;
    animation-fill-mode: both;
    -webkit-box-shadow: 0 0 0 1000px var(--sds-color-background-default-secondary) inset !important;
    -webkit-text-fill-color: var(--sds-color-text-default-default) !important;
  }

  input[type="date"]:in-range::-webkit-datetime-edit-year-field,
  input[type="date"]:in-range::-webkit-datetime-edit-month-field,
  input[type="date"]:in-range::-webkit-datetime-edit-day-field,
  input[type="date"]:in-range::-webkit-datetime-edit-text {
    color: transparent;
  }

  input.has-value {
    &[type="date"]:in-range::-webkit-datetime-edit-year-field,
    &[type="date"]:in-range::-webkit-datetime-edit-month-field,
    &[type="date"]:in-range::-webkit-datetime-edit-day-field,
    &[type="date"]:in-range::-webkit-datetime-edit-text {
      color: inherit;
    }
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    background: transparent;
    inset: 0 0 0 0;
    color: transparent;
    cursor: pointer;
    height: auto;
    position: absolute;
    width: auto;
  }

  @keyframes wow-autocomplete-detected {
    from {
    }
    to {
    }
  }

  .input-placeholder {
    position: absolute;
    left: var(--sds-size-space-600);
    top: 50%;
    transform: translateY(-50%);
    font:
      var(--sds-typography-weight-medium) var(--sds-typography-body-size-large) / 1em var(--sds-typography-family-title),
      sans-serif;
    color: var(--sds-color-text-default-tertiary);
    transition: all 0.2s ease-out;
    pointer-events: none;

    &.active {
      top: var(--sds-size-space-300);
      transform: translateY(0);
      font-size: var(--sds-typography-body-size-small);
    }

    &.error-message {
      color: var(--sds-color-text-danger-secondary);
    }

    &.disabled {
      color: var(--sds-color-text-disabled-default);
    }
  }

  .password-toggle {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: var(--sds-size-space-600);
  }

  .required-indicator {
    color: var(--sds-color-text-danger-secondary);
    margin-left: var(--sds-size-space-100);
  }
`;
